<template>
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mx-3 border-bottom">
	<h4 v-if="isNoConnectionToServer">Немає св'язку з сервером</h4>
	<h4 v-else-if="isNoPost">Контрольно вимірювальний пункт не знайдено</h4>
	<div v-else-if="post !== undefined">
		<span class="fs-5">
			КВП 
			<b class="fw-bold">
				{{ `"${post.passport.get('name')}"`}}
			</b>
		</span>
	</div>
	<div v-else>
		<span class="fs-5">
			Не можемо знайти Контрольно вимірювальний пункт. Спробуйте ще, або зверніться до адміністратора.
		</span>
	</div>

	<div v-show="['post_settings', 'post_passport'].includes($route.name)">
		<span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" data-bs-title="історія змін">
			<button
				v-if="accountStore.isPrimary"
				type="button"
				class="btn btn-sm btn-outline-secondary m-0 me-2 p-0"
				@click="$router.push({ name: 'post_passport_history',})"
				style="border: 1; width: 32px; aspect-ratio: 1;"
			>
				<button-icon icon="clock-history" color="currentColor" edge-size="20" />
			</button>
		</span>

		<span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" data-bs-title="таблиця налаштувань">
			<button
				type="button"
				class="btn btn-sm btn-outline-secondary m-0 p-0"
				@click="$router.push({ name: 'post_passport_table',})"
				style="border: 1; width: 32px; aspect-ratio: 1;"
			>
				<button-icon icon="table" color="currentColor" edge-size="20" />
			</button>
		</span>
	</div>
</div>

<section v-if="postsStore.isNoPosts || isLoading" class="w-100 h-100 m-0 p-0">
	<div class="d-flex flex-column justify-content-center align-items-center h-100 w-100">
		<div class="spinner-border text-secondary app-spinner" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</div>
</section>
<section class="m-0 p-0 px-1">
	<!-- set postId and objectId for post sections and common sections compatibility -->
	<router-view
		v-if="postsStore.isNoPosts === false"
		:postId="postId"
		:objectId="postId"
		viewportMinutes="1440"
	>
	</router-view>
</section>
</template>


<script>
import { useTooltip } from '@/composables/bootstrap-tooltip.js'
import { inject } from 'vue'
import ButtonIcon from '@/components/Icons/ButtonIcon.vue'
import { useAccontStore } from '@/stores/AccountStore'
import { usePostsStore } from '@/stores/PostsStore'
import { CustomNavTabs, EmptyNavSection } from '@/customNavSection.js'
import {
} from '@/helpers.js'


export default {
	metrics_update_rate: 5000,
	
	inject: ['customNavSection'],

	components: {
		ButtonIcon,
	},

	props: {
	},

	setup() {
		const accountStore = useAccontStore()
		const postsStore = usePostsStore()

		useTooltip()

		return {
			accountStore,
			postsStore,
		}
	},

	data() {
		return {
			// State flags
			isNoPost: false,
			isNoConnectionToServer: false,
			isLoading: true,

			// Metrics update timer
			updateInterval: null,

			//
			postId: undefined,
		}
	},

	watch: {
		route() {
			this.updateSections()
		},
	},

	async created() {
		this.isLoading = true
		// Create custom navigation
		this.customNavSection = new CustomNavTabs()

		// Read id from url
		try {
			this.postId = this.$route.params.id
		} catch {
			console.error("On post id read.")
			this.isNoConnectionToServer = true
			return
		}

		// Read post passport
		await this.postsStore.readPassport(
			(result) => {
				if (!result) {
					console.error("Can't read post passport!")
				}
			},
			this.postId,
		)

		await this.updatePost()

		// Read post metrics and alerts
		// Updates every * seconds
		this.updateInterval = setInterval(async () => {
			this.updatePost()
		}, this.$options.metrics_update_rate)

		this.isLoading = false
	},

	mounted() {
		this.updateSections()
	},

	methods: {
		updateSections() {
			// Create custom navigation data model
			let control = false, view_report = false, log = false, settings = false, passport = false,
				history = false, passport_table = false

			// console.log("Add tabs ", this.$route.name)

			// Add tabs
			this.tabs.addLine('post_control', 'Телеконтроль', null, control)
			this.tabs.addLine('post_view_report', 'Аналіз даних', null, view_report)
			this.tabs.addLine('post_log', 'Лоґ', null, log, undefined, {permission: 'view_log'})
			this.tabs.addLine('post_settings', 'Налаштування', null, settings)
			this.tabs.addLine('post_passport', 'Паспорт', null, passport)
			if (this.$route.name == 'post_passport_history') {
				this.tabs.addLine('post_passport_history', 'Історія', null, history)
			}
			if (this.$route.name == 'post_passport_table') {
				this.tabs.addLine('post_passport_table', 'Таблиця налаштувань', null, passport_table)
			}

			// Marck active tab on page load
			this.tabs.checkTab(this.$route.name)
		},

		async updatePost() {
			// Read metrics
			await this.postsStore.readMetrics(
				(result) => {
					if (result) {
						this.isNoConnectionToServer = false
						const post = this.postsStore.post(this.postId)
						this.isNoPost = post == undefined
						if (!this.isNoPost) {
							document.title = post.passport.has("name") ?
								post.passport.get("name") : "КВП"

							//console.log("Post updated ", post)
						}
					} else {
						console.error("No connection on read Metrics")
						this.isNoConnectionToServer = true
					}
				},
				this.postId,
			)
		}
	},

	computed: {
		post() {
			return this.postsStore.post(this.postId)
		},

		tabs() {
			return this.customNavSection
		},

		route() {
			return this.$route.name
		},
	},

	beforeUnmount() {
		// Clear custom nav section
		let navCustom = inject('customNavSection')
		navCustom.value = new EmptyNavSection()
		
		if (this.updateInterval != null) {
			clearInterval(this.updateInterval)
			this.updateInterval = null
		}
	},

	unmounted() {},
}
</script>

<style src="@/assets/widget.css" scoped></style>
<style scoped>
</style>
